mutation Inertia_DestroyParticipant($participantId: ID!) {
  destroyParticipant(input: { participantId: $participantId }) {
    success
    errors
  }
}